import { BulkLoader } from "../loader/BulkLoader";
import { BasicItemJsonData } from "./BasicItemJsonData";
import { ClipSourceFactory } from "./ClipSourceFactory";
import { AnimationManager } from "./AnimationManager";

import { fatal } from "../logging/fatal";
import { ClipCacheController } from "./cache/ClipCacheController";
import { ICacheController } from "./cache/ICacheController";

//import PixelSnapping = createjs.PixelSnapping;
import Stage = createjs.Stage;

export class GoodgameBitmapEngine {
    // TODO: @HTML5
    private static _bulkLoader: BulkLoader;

    // TODO: @HTML5
    public static get bulkLoader(): BulkLoader {
        return GoodgameBitmapEngine._bulkLoader;
    }

    private static _itemJsonData: BasicItemJsonData;

    // TODO: @HTML5
    public static numConnections: number = 0;//BulkLoader.DEFAULT_NUM_CONNECTIONS;

    private static _instance: GoodgameBitmapEngine;

    public static get instance(): GoodgameBitmapEngine {
        if (!GoodgameBitmapEngine._instance) {
            GoodgameBitmapEngine._instance = new GoodgameBitmapEngine();
        }
        return GoodgameBitmapEngine._instance;
    }

    /** reference to clip factory. */
    private static _clipFactory: ClipSourceFactory;

    /** reference to clip factory. */
    public static get clipFactory(): ClipSourceFactory {
        if (!GoodgameBitmapEngine._clipFactory) {
            fatal("clip factory not initalized");
            return null;
        }
        else {
            return GoodgameBitmapEngine._clipFactory;
        }
    }

    private static _cacheController: ICacheController;

    /** cache controller for this framework. */
    public static get cacheController(): ICacheController {
        return GoodgameBitmapEngine._cacheController;
    }

    private _smoothing: boolean = false;
    private _allowQualityChangeOnBitmapCreation: boolean = true;

    public get smoothing(): boolean {
        return this._smoothing;
    }

    public set smoothing(value: boolean) {
        this._smoothing = value;
    }

    //private _pixelSnapping: string = PixelSnapping.NEVER;

    public get pixelSnapping(): string {
        // TODO: @HTML5
        return "";
    }

    public set pixelSnapping(value: string) {
        // TODO: @HTML5
        //this._pixelSnapping = value;
    }

    private static _useCacheAsBitmapForDisplayObjects: boolean = true;

    public static get useCacheAsBitmapForDisplayObjects(): boolean {
        return GoodgameBitmapEngine._useCacheAsBitmapForDisplayObjects;
    }

    public static set useCacheAsBitmapForDisplayObjects(value: boolean) {
        GoodgameBitmapEngine._useCacheAsBitmapForDisplayObjects = value;
    }

    private _debugShowPlaceholder: boolean = false;

    public get debugShowPlaceholder(): boolean {
        return this._debugShowPlaceholder;
    }

    public set debugShowPlaceholder(value: boolean) {
        this._debugShowPlaceholder = value;
    }

    /** reference to animation manager. */
    private _animationManager: AnimationManager;

    /** reference to animation manager. */
    public get animationManager(): AnimationManager {
        if (!this._animationManager) {
            fatal("animation manager not initalized");
            return null;
        }
        else {
            return this._animationManager;
        }
    }

    private static _stage: Stage;

    public static get stage(): Stage {
        return GoodgameBitmapEngine._stage;
    }

    public static setStageQuality(quality: string): void {
        if (GoodgameBitmapEngine._stage) {
            // TODO: @HTML5
            //GoodgameBitmapEngine._stage.quality = quality;
        }
    }

    // TODO: @HTML5
    public init(stage: Stage, debugMode: boolean = false, usableBulkLoader: any = null): void {
        GoodgameBitmapEngine._stage = stage;
        // TODO: @HTML5
        GoodgameBitmapEngine._bulkLoader = usableBulkLoader || new BulkLoader("BitmapEngineLoader");
        this._animationManager = new AnimationManager();
        GoodgameBitmapEngine._clipFactory = new ClipSourceFactory(debugMode);
        GoodgameBitmapEngine._cacheController = new ClipCacheController();
    }

    public static get itemJsonData(): BasicItemJsonData {
        return GoodgameBitmapEngine._itemJsonData;
    }

    public static set itemJsonData(value: BasicItemJsonData) {
        GoodgameBitmapEngine._itemJsonData = value;
    }

    public get allowQualityChangeOnBitmapCreation(): boolean {
        return this._allowQualityChangeOnBitmapCreation;
    }

    public set allowQualityChangeOnBitmapCreation(value: boolean) {
        this._allowQualityChangeOnBitmapCreation = value;
    }
}
